import * as HazardPromptPermit from '../schemas/permits/Westpac/hazardPromptPermit.json'

export default {
    type: 'Westpac Permit',
    schemas: {
        'Westpac Hazard Prompt Permit': HazardPromptPermit,
    },
}
